<template>
  <div>
    <!-- 商品备注编辑 -->
    <el-dialog :title="$t('message.commodityNoteEditing')" :close-on-click-modal="false"
      :visible.sync="$parent.commodityNoteDialogVisible" width="456px" center>
      <div class="content">
        <el-input v-model="datas.remark" type="textarea" resize="none">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.commodityNoteDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="updateOrderDetailRemark">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    data: { type: Object },
  },
  data() {
    return {
      userRoleStatus: localStorage.getItem("japanUserRoleStatus"),
      datas: { remark: "", remark_type: "", order_detail_id: "" },
    };
  },
  created() {
    if (this.userRoleStatus == 1) {
      this.datas.remark = this.data.y_remark;
      this.datas.remark_type = "Y";
    } else if (this.userRoleStatus == 2) {
      this.datas.remark = this.data.g_remark;
      this.datas.remark_type = "G";
    } else if (this.userRoleStatus == 5) {
      this.datas.remark = this.data.p_remark;
      this.datas.remark_type = "P";
    }
    this.datas.order_detail_id = this.data.order_detail_id;
  },
  methods: {
    updateOrderDetailRemark() {
      this.$api.inspectionApi
        .updateOrderDetailRemark(this.datas)
        .then((res) => {
          this.$message.success(res.msg);
          this.$parent.uploadRemark(this.datas);
        });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;

  /deep/.el-textarea__inner {
    padding: 5px;
    height: 200px;
  }
}
</style>